import { PureComponent } from "react";

import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";

import BackgroundColorThumbnailItemComponent from "../background-color-thumbnail-item/background-color-thumbnail-item-component";
import BackgroundImageThumbnailItemComponent from "../background-image-thumbnail-item/background-image-thumbnail-item-component";

const THUMBNAILS_TYPE_TO_COMPONENT_MAPPING = {
  [THUMBNAILS_TYPES.BACKGROUND_COLOR]: BackgroundColorThumbnailItemComponent,
  [THUMBNAILS_TYPES.BACKGROUND_IMAGE]: BackgroundImageThumbnailItemComponent
};

export default class BaseThumbnailItemComponent extends PureComponent {
  mapThumbnailTypeToComponent() {
    const { thumbnailType } = this.props;
    return THUMBNAILS_TYPE_TO_COMPONENT_MAPPING[thumbnailType];
  }

  render() {
    const ThumbnailComponent = this.mapThumbnailTypeToComponent();
    return <ThumbnailComponent {...this.props} />;
  }
}

BaseThumbnailItemComponent.defaultProps = {
  thumbnailType: THUMBNAILS_TYPES.BACKGROUND_COLOR
};
